import React from "react";

import { createBrowserRouter, Navigate } from "react-router-dom";
import "./index.css";
import { CreateGroup } from "./components/Circle";

import PrivateRouter from "./components/routers/PrivateRouter";
import CirclePage from "./components/Circle/CirclePage/CirclePage";
import LoginPortal from "./components/Users/LoginPortal";
import NewSettings from "components/Profile/";
import ViewGroupImproved from "./components/Circle/ViewGroupImproved";
import RegisterBankInitial from "./components/Users/RegisterBankInitial";

import Layout from "./components/routers/Layout";
import { PublicRouter } from "./components/routers/PublicRouter";
import SandooqLanding from "screens/Landing/LandingPage";
import NotificationsPage from "screens/Notifications/NotificationsPage";
import { OnboardingPage, OnboardingSuccess } from "screens/Onboarding";
import {
  DisclaimerPage,
  PrivacyPolicyPage,
  TermsOfServicePage,
  HowItWorksPage,
} from "screens/Legal";
import JoinCirclePage from "screens/Join/JoinCirclePage";
export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <PublicRouter>
        <Layout />
      </PublicRouter>
    ),
    children: [
      { path: "/home", element: <SandooqLanding /> },
      { path: "/login", element: <LoginPortal /> },
      { path: "/register", element: <LoginPortal /> },
      { path: "/confirm", element: <LoginPortal /> },
      { path: "/forgot-password", element: <LoginPortal /> },
      { path: "/reset-password", element: <LoginPortal /> },
      { path: "*", element: <Navigate to="/home" replace /> }, // redirect to login by default
    ],
  },
  {
    path: "/",
    element: (
      <PrivateRouter>
        <Layout />
      </PrivateRouter>
    ),
    children: [
      { path: "/view-group", element: <ViewGroupImproved /> },
      { path: "/create-group", element: <CreateGroup /> },
      { path: "/circles/:groupId", element: <CirclePage /> },
      { path: "/settings/*", element: <NewSettings /> },
      { path: "/setup", element: <RegisterBankInitial /> },
      { path: "/notifications", element: <NotificationsPage /> },
      { path: "/onboarding", element: <OnboardingPage /> },
      { path: "/onboarding/success", element: <OnboardingSuccess /> },
      { path: "*", element: <Navigate to="/view-group" replace /> }, // redirect to view-group by default
      { index: true, element: <ViewGroupImproved /> }, // default redirect
    ],
  },
  {
    path: "*",
    element: <Navigate to="/view-group" replace />,
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "/how-it-works", element: <HowItWorksPage /> },
      { path: "/privacy", element: <PrivacyPolicyPage /> },
      { path: "/terms", element: <TermsOfServicePage /> },
      { path: "/disclaimer", element: <DisclaimerPage /> },
      // Public invite-link landing page — must work logged-in AND logged-out,
      // so it lives outside both PublicRouter and PrivateRouter.
      { path: "/join/:token", element: <JoinCirclePage /> },
    ],
  },
]);
